import { Link } from "react-router-dom";
import { ArrowRight, Check, ChatCircleDots } from "@phosphor-icons/react";
import { SiStripe, SiQuickbooks } from "react-icons/si";
import { Bank } from "@phosphor-icons/react";

const Step = ({ n, title, body, children, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-[#2A2A2A] bg-[#121212] p-6 flex flex-col">
    <p className="font-mono text-xs text-[#00FF9D]">STEP {n}</p>
    <h3 className="font-display text-xl mt-2">{title}</h3>
    <p className="mt-2 text-sm text-[#A3A3A3] leading-relaxed">{body}</p>
    <div className="mt-6 flex-1 rounded-xl border border-[#2A2A2A] bg-[#0A0A0A] p-4">{children}</div>
  </div>
);

const Sources = () => (
  <ul className="space-y-2 text-sm">
    {[[SiStripe, "Stripe", "#635BFF", "MRR $18,400"], [Bank, "Bank", "#00FF9D", "Cash $412,850"], [SiQuickbooks, "QuickBooks", "#2CA01C", "Bills $9,120"]].map(([I, n, c, v]) => (
      <li key={n} className="flex items-center gap-2"><I size={15} style={{ color: c }} /> {n}<span className="ml-auto font-mono text-xs text-[#A3A3A3]">{v}</span><Check className="text-[#00FF9D]" weight="bold" /></li>
    ))}
  </ul>
);

const Zcd = () => (
  <div className="font-mono">
    <p className="text-[11px] text-[#A3A3A3]">ZERO CASH DATE</p>
    <p className="text-2xl mt-1">Mar 14, 2027</p>
    <p className="text-[11px] text-[#A3A3A3] mt-3">RUNWAY</p>
    <p className="text-lg text-[#00FF9D]">16.2 months</p>
    <div className="mt-3 h-1.5 rounded-full bg-[#2A2A2A]"><div className="h-full w-3/4 rounded-full bg-[#00FF9D]" /></div>
  </div>
);

const Scenario = () => (
  <div className="text-sm">
    <p className="font-mono text-xs"><ChatCircleDots className="inline text-[#9D00FF] mr-1" />What if we hire two engineers in Q3?</p>
    <ul className="mt-3 space-y-1 font-mono text-xs text-[#A3A3A3]">
      <li>+ Payroll $24,000/mo from Jul</li>
      <li>Runway 16.2 → <span className="text-[#9D00FF]">12.9 months</span></li>
    </ul>
    <p className="mt-3 text-[11px] text-[#A3A3A3]">Saved as a scenario. Your baseline is unchanged.</p>
  </div>
);

export const Walkthrough = () => (
  <section id="walkthrough" data-testid="walkthrough-section" className="border-b border-[#2A2A2A] scroll-mt-16">
    <div className="mx-auto max-w-7xl px-6 py-20 md:py-28">
      <p className="font-mono text-xs text-[#00FF9D] mb-4">// SEE THE DASHBOARD</p>
      <h2 className="font-display text-3xl md:text-4xl font-semibold max-w-2xl">From three logins to one runway number, in three steps.</h2>
      <p className="mt-3 text-xs font-mono text-[#A3A3A3]">Sample company data shown.</p>
      <div className="mt-12 grid md:grid-cols-3 gap-6">
        <Step n={1} testid="walkthrough-step-1" title="Connect your sources" body="Link Stripe, your bank and QuickBooks. CalibRunway reads them and reconciles one cash position."><Sources /></Step>
        <Step n={2} testid="walkthrough-step-2" title="See your Zero Cash Date" body="The exact day cash runs out at today's burn, updated every time you open the dashboard."><Zcd /></Step>
        <Step n={3} testid="walkthrough-step-3" title="Test a move before you make it" body="Ask the AI Calibrator a what-if and compare it side by side with your baseline."><Scenario /></Step>
      </div>
      <Link to="/sign-up" data-testid="walkthrough-cta-btn" className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-[#00FF9D] hover:text-white transition-colors">
        Try it with your own numbers, free for 14 days <ArrowRight weight="bold" />
      </Link>
    </div>
  </section>
);
